// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kG","show":"kH","dark":"kI","top":"kJ","bottom":"kK","left":"kL","right":"kM"};